import { Component, Emit, Prop, Vue, Watch } from 'vue-property-decorator';
@Component({
    name: 'OtpInputSingle',
})
export default class default_1 extends Vue {
    @Prop()
    value;
    @Prop()
    hasFocus;
    // NOTE: this is a prop because the autofocus attr has bad compatibility with older iOS (tested on iOS 16.4 and 18.5)
    @Prop({ default: false })
    autofocus;
    @Prop({ default: 'text' })
    inputType;
    @Prop({ default: 'text' })
    inputMode;
    @Prop({ default: false })
    autocapitalize;
    localValue = this.value;
    created() {
        document.addEventListener('selectionchange', this.handleSelectionReset);
    }
    destroyed() {
        document.removeEventListener('selectionchange', this.handleSelectionReset);
    }
    mounted() {
        // in some situations, the `autofocus` attribute in the dom isn't respected, so we need to set focus via js
        if (this.autofocus)
            this.focus();
    }
    focus() {
        const input = this.$refs.input;
        input.focus();
    }
    /** Ensure the entire input is selected, so that typing a character will always replace the value. This handler should be attached to the document, not the input element, for compatibility with older browsers. https://caniuse.com/?search=selectionchange */
    handleSelectionReset() {
        const input = this.$refs.input;
        if (document.activeElement !== input)
            return;
        if (input.selectionStart !== 0 || input.selectionEnd !== 0) {
            this.resetSelectionIfFocused();
        }
    }
    /** Sanitise input so only valid characters are allowed, and reset input element to a valid value */
    handleInput(event) {
        const input = event.target;
        const validPattern = this.inputType === 'number' ? /^[0-9]$/ : /^[a-zA-Z0-9]$/;
        const isValidInput = validPattern.test(event.data ?? '');
        if (isValidInput)
            this.localValue = this.autocapitalize ? event.data.toUpperCase() : event.data;
        // at this point, the input element might have an invalid value in the DOM state, so force update the input element so that the component (this and the parent's) logic never runs with an invalid value
        input.value = this.localValue;
        if (isValidInput)
            this.emitChange(this.localValue);
    }
    @Watch('value')
    onValueChange() {
        this.localValue = this.value;
        this.$nextTick(() => this.resetSelectionIfFocused());
    }
    resetSelectionIfFocused() {
        const input = this.$refs.input;
        if (!input || document.activeElement !== input)
            return;
        const collapseSelection = () => {
            input.selectionStart = 0;
            input.selectionEnd = 0;
        };
        collapseSelection();
        // WebKit may re-expand selection after value/DOM updates; run again on the next frame.
        requestAnimationFrame(() => collapseSelection());
    }
    @Watch('hasFocus')
    onFocusChange() {
        if (this.hasFocus)
            this.focus();
    }
    @Emit('on-keydown')
    handleKeyDown(event) {
        return event;
    }
    @Emit('on-paste')
    handlePaste(event) {
        return event;
    }
    @Emit('on-focus')
    handleFocus() { }
    @Emit('on-blur')
    handleBlur() { }
    @Emit('on-change')
    emitChange(value) {
        return value;
    }
}
